import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


// --------------------------------------------------------------DEVOLUCIONES INTERNAS-------------------------------------------------------------------------

// OBTENER DEVOLUCIONES INTERNAS POR FECHA CON EL PROCEDIMIENTO
export const ObtDevolucionesInternas = async (data) => {
    return await PrivateInterceptor('Devoluciones/DevolucionesInternas/DevolucionesInternasPorFecha', 'POST', data);
}

//GUARDAR DEVOLUCIONES INTERNAS
export const guardarDevolucionesI = async (datos) => {
    return await PrivateInterceptor('Devoluciones/DevolucionesInternas/AgregarDevolucionesInternas', 'POST', {datos});

}

//GUARDAR DEVOLUCIONES INTERNAS
export const editarDevolucionesI = async (datos) => {
    return await PrivateInterceptor('Devoluciones/DevolucionesInternas/EditarDevolucionesInternas', 'POST', {datos});
}

// ELIMINAR DEVOLUCION
export const EliminarDevolucion = async (datos) => {
    const respuesta = await PrivateInterceptor("Devoluciones/DevolucionesInternas/EliminarDevolucionesInternas", "POST",{datos});
    return respuesta;
};

export const agregarConstruccionDevoluciones = async (data) => {
  return await PrivateInterceptor('Devoluciones/DevolucionesInternas/agregarConstruccionDevoluciones', 'POST', {data});
}

export const agregarCuentaDevoluciones = async (data) => {
  return await PrivateInterceptor('Devoluciones/DevolucionesInternas/agregarCuentaDevoluciones', 'POST', {data});
}

export const revisarDevolucionesFin = async (data) => {
  return await PrivateInterceptor('Devoluciones/DevolucionesInternas/revisarDevolucionesFin', 'POST', {data});
}

// --------------------------------------------------------------DEVOLUCIONES A PROVEEDORES-------------------------------------------------------------------------

// OBTENER DEVOLUCIONES A PROVEEDOR POR FECHA CON EL PROCEDIMIENTO
export const ObtDevolucionesProveedor = async (data) => {
    return await PrivateInterceptor('Devoluciones/DevolucionesProveedor/DevolucionesProveedorPorFecha', 'POST', data);
}

// GUARDAR DEVOLUCION A PROVEEDOR
export const GuardarDevolucionProveedor = async (datos) => {
    const respuesta = PrivateInterceptor("Devoluciones/DevolucionesProveedor/AgregarDevolucionMaterialProveedor", "POST",{datos});
    return respuesta;
  };

  // GUARDAR DEVOLUCION A PROVEEDOR
export const EditarDevolucionProveedor = async (datos) => {
    const respuesta = PrivateInterceptor("Devoluciones/DevolucionesProveedor/EditarDevolucionMaterialProveedor", "POST",{datos});
    return respuesta;
};

// GUARDAR DEVOLUCION A PROVEEDOR
export const EliminarDevolucionProveedor = async (datos) => {
const respuesta = PrivateInterceptor("Devoluciones/DevolucionesProveedor/EliminarDevolucionMaterialProveedor", "POST",{datos});
return respuesta;
};